const heroHeaders = {
  special_consideration: `Best Rehabs @customTermHeader`,
  activity: `Best Rehabs @customTermHeader`,
  accepted_insurance: `Best Rehabs @customTermHeader`,
  insurance_accepted: `Best Rehabs @customTermHeader`,
  treatment_therapy: `Best Rehabs @customTermHeader`,
  treatment_services: `Best @customTermHeader`,
  amenities: `Best @customTermHeader`,
  setting: `Best Rehabs @customTermHeader`,
  treatment_method: `Best @customTermHeader`,
  what_we_treat: `Best @customTermHeader`,
  price: `Best @customTermHeader`,
  who_we_treat: `Best @customTermHeader`,
  'Location+who_we_treat': `Best @customTermHeader in @title`,
  'Location+accepted_insurance': `Best Rehabs @customTermHeader in @title`,
  'Location+insurance_accepted': `Best Rehabs @customTermHeader in @title`,
  'Location+treatment_methods': `Best @customTermHeader in @title`,
  'Location+special_consideration': `Best Rehabs @customTermHeader in @title`,
  'Location+special_considerations': `Best Rehabs @customTermHeader in @title`,
  'Location+treatment_therapies': `Best Rehabs @customTermHeader in @title `,
  'Location+treatment_services': `Best @customTermHeader in @title`,
  'Location+activities': `Best Rehabs @customTermHeader in @title`,
  'Location+amenities': `Best @customTermHeader in @title`,
  'Location+setting': `Best Rehabs @customTermHeader in @title`,
  'Location+price': `Best @customTermHeader in @title`,
  'Location+what_we_treat': `Best @customTermHeader in @title`
}

const featuredCentersHeaders = {
  Location: `Featured Treatment Centers in @title`,
  special_consideration: `Featured Treatment Centers @customTermHeader`,
  activity: `Featured Treatment Centers @customTermHeader`,
  accepted_insurance: `Featured Treatment Centers @customTermHeader`,
  insurance_accepted: `Featured Treatment Centers @customTermHeader`,
  treatment_therapy: `Featured Treatment Centers @customTermHeader`,
  treatment_therapies: `Featured Treatment Centers @customTermHeader`,
  treatment_services: `Featured @customTermHeader`,
  amenities: `Featured @customTermHeader`,
  setting: `Featured Treatment Centers @customTermHeader`,
  treatment_method: `Featured @customTermHeader`,
  what_we_treat: `Featured @customTermHeader`,
  price: `Featured @customTermHeader`,
  who_we_treat: `Featured @customTermHeader`,
  'Location+who_we_treat': `Featured @customTermHeader`,
  'Location+accepted_insurance': `Featured Treatment Centers @customTermHeader`,
  'Location+insurance_accepted': `Featured Treatment Centers @customTermHeader`,
  'Location+treatment_methods': `Featured @customTermHeader`,
  'Location+special_consideration': `Featured Treatment Centers @customTermHeader`,
  'Location+special_considerations': `Featured Treatment Centers @customTermHeader`,
  'Location+treatment_therapies': `Featured Treatment Centers @customTermHeader`,
  'Location+treatment_services': `Featured @customTermHeader`,
  'Location+activities': `Featured Treatment Centers @customTermHeader`,
  'Location+amenities': `Featured @customTermHeader`,
  'Location+setting': `Featured Treatment Centers @customTermHeader`,
  'Location+price': `Featured @customTermHeader`,
  'Location+what_we_treat': `Featured @customTermHeader`
}

const centerFeedHeaders = {
  Location: `Alcohol & Drug Rehab Centers`,
  special_consideration: `Best Rehabs @customTermHeader`,
  activity: `Best Rehabs @customTermHeader`,
  accepted_insurance: `Best Rehabs @customTermHeader`,
  insurance_accepted: `Best Rehabs @customTermHeader`,
  treatment_therapy: `Best Rehabs @customTermHeader`,
  treatment_services: `Best @customTermHeader`,
  amenities: `Best @customTermHeader`,
  setting: `Best Rehabs @customTermHeader`,
  treatment_method: `@customTermHeader`,
  what_we_treat: `Best @customTermHeader`,
  price: `Best @customTermHeader`,
  who_we_treat: `Best @customTermHeader`,
  'Location+who_we_treat': `Best Centers in @title`,
  'Location+accepted_insurance': `Best Centers in @title`,
  'Location+insurance_accepted': `Best Centers in @title`,
  'Location+treatment_methods': `Best Centers in @title`,
  'Location+special_consideration': `Best Centers in @title`,
  'Location+special_considerations': `Best Centers in @title`,
  'Location+treatment_therapies': `Best Centers in @title`,
  'Location+treatment_services': `Best Centers in @title`,
  'Location+activities': `Best Centers in @title`,
  'Location+amenities': `Best Centers in @title`,
  'Location+setting': `Best Centers in @title`,
  'Location+price': `Best Centers in @title`,
  'Location+what_we_treat': `Best Centers in @title`
}
const FAQHeaders = {
  Location: `Common Questions About @title Treatment Centers`,
  special_consideration: `Common Questions About Treatment Centers @customTermHeader`,
  activity: `Common Questions About Treatment Centers @customTermHeader`,
  accepted_insurance: `Common Questions About Treatment Centers @customTermHeader`,
  insurance_accepted: `Common Questions About Treatment Centers @customTermHeader`,
  treatment_therapy: `Common Questions About Treatment Centers @customTermHeader`,
  treatment_services: `Common Questions About @customTermHeader`,
  amenities: `Common Questions About @customTermHeader`,
  setting: `Common Questions About Centers Treatment Centers @customTermHeader`,
  treatment_method: `Common Questions About @customTermHeader`,
  what_we_treat: `Common Questions About @customTermHeader`,
  price: `Common Questions About @customTermHeader`,
  who_we_treat: `Common Questions About @customTermHeader`,
  'Location+who_we_treat': `Common Questions About @customTermHeader in @title`,
  'Location+accepted_insurance': `Common Questions About Treatment Centers @customTermHeader in @title`,
  'Location+insurance_accepted': `Common Questions About Treatment Centers @customTermHeader in @title`,
  'Location+treatment_methods': `Common Questions About @customTermHeader in @title`,
  'Location+treatment_services': `Common Questions About @customTermHeader in @title`,
  'Location+special_consideration': `Common Questions About Treatment Centers @customTermHeader in @title`,
  'Location+special_considerations': `Common Questions About Treatment Centers @customTermHeader in @title`,
  'Location+treatment_therapies': `Common Questions About Treatment Centers @customTermHeader in @title`,
  'Location+activities': `Common Questions About Treatment Centers @customTermHeader in @title`,
  'Location+amenities': `Common Questions About @customTermHeader in @title`,
  'Location+setting': `Common Questions About Treatment Centers @customTermHeader in @title`,
  'Location+price': `Common Questions About @customTermHeader in @title`,
  'Location+what_we_treat': `Common Questions About @customTermHeader in @title`
}

const descriptionBoxHeaders = {
  Location: `Rehab in @title`,
  special_consideration: `More About Rehabs @customTermHeader`,
  activity: `More About Rehabs @customTermHeader`,
  accepted_insurance: `More About Rehabs @customTermHeader`,
  insurance_accepted: `More About Rehabs @customTermHeader`,
  treatment_therapy: `More About Rehabs @customTermHeader`,
  treatment_services: `More About @customTermHeader`,
  amenities: `More About @customTermHeader`,
  setting: `More About Rehabs @customTermHeader`,
  treatment_method: `More About @customTermHeader`,
  what_we_treat: `More About @customTermHeader`,
  price: `More About @customTermHeader`,
  who_we_treat: `More About @customTermHeader`,
  'Location+who_we_treat': `More About @customTermHeader`,
  'Location+accepted_insurance': `More About Rehabs @customTermHeader`,
  'Location+insurance_accepted': `More About Rehabs @customTermHeader`,
  'Location+treatment_methods': `More About @customTermHeader`,
  'Location+special_consideration': `More About Rehabs @customTermHeader`,
  'Location+special_considerations': `More About Rehabs @customTermHeader`,
  'Location+treatment_therapies': `More About Rehabs @customTermHeader`,
  'Location+treatment_services': `More About @customTermHeader`,
  'Location+activities': `More About Rehabs @customTermHeader`,
  'Location+amenities': `More About @customTermHeader`,
  'Location+setting': `More About Rehabs @customTermHeader`,
  'Location+price': `More About @customTermHeader`,
  'Location+what_we_treat': `More About @customTermHeader`
}

const nearbyFeedHeaders = {
  'Location+who_we_treat': `@customTermHeader near @title`,
  'Location+accepted_insurance': `Treatment Centers near @title @customTermHeader`,
  'Location+insurance_accepted': `Treatment Centers near @title @customTermHeader`,
  'Location+treatment_methods': `@customTermHeader near @title`,
  'Location+special_consideration': `Treatment Centers near @title @customTermHeader`,
  'Location+special_considerations': `Treatment Centers near @title @customTermHeader`,
  'Location+treatment_therapies': `Treatment Centers near @title @customTermHeader`,
  'Location+treatment_services': `@customTermHeader near @title`,
  'Location+activities': `Treatment Centers near @title @customTermHeader`,
  'Location+amenities': `@customTermHeader near @title`,
  'Location+setting': `Treatment Centers near @title @customTermHeader`,
  'Location+price': `@customTermHeader near @title`,
  'Location+what_we_treat': `@customTermHeader near @title`
}

export enum CustomHeaderType {
  FEATURED_CENTERS,
  CENTER_FEED,
  DESCRIPTION_BOX,
  FAQ,
  HERO,
  NEARBY_FEED
}

export const CUSTOM_HEADERS = {
  [CustomHeaderType.FEATURED_CENTERS]: featuredCentersHeaders,
  [CustomHeaderType.CENTER_FEED]: centerFeedHeaders,
  [CustomHeaderType.DESCRIPTION_BOX]: descriptionBoxHeaders,
  [CustomHeaderType.FAQ]: FAQHeaders,
  [CustomHeaderType.HERO]: heroHeaders,
  [CustomHeaderType.NEARBY_FEED]: nearbyFeedHeaders
}
